import { useCallback } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { NormalizedFormValues } from '#src/app/pages/petitionDetails/shared/types';
import { useCurrentUserIdAsync } from '#src/app/shared/hooks/session';
import { useSessionStorageValueAsync } from '#src/app/shared/hooks/storage';
import { isLoaded } from '#src/app/shared/utils/async';

type Result = (formData: NormalizedFormValues) => void;

export function useSetSessionStoredReasonForSigning(): Result {
	const userIdState = useCurrentUserIdAsync();
	const userId = isLoaded(userIdState) ? userIdState.value : undefined;

	const {
		data: {
			petition: { id: petitionId },
			featureConfigs: { storeReasonForSigning },
		},
	} = usePetitionDetailsPageData();
	const [, setReasonForSigningStr] = useSessionStorageValueAsync(
		`reason-for-signing-${userId || 'unknown'}-${petitionId}`,
	);

	return useCallback(
		(formData) => {
			if (!storeReasonForSigning || !userId || !formData.reasonForSigning) {
				return;
			}
			// TODO: condition this on cookie prefs?
			setReasonForSigningStr(
				JSON.stringify({
					message: formData.reasonForSigning,
					public: formData.public,
				}),
			);
		},
		[storeReasonForSigning, userId, setReasonForSigningStr],
	);
}
